import api from '@/utils/apiClient'

export function authenticatedFileUrl (baseUrl, path) {
  const server = String(baseUrl || '').replace(/\/$/, '')
  return `${server}/send_file_auth?path=${encodeURIComponent(path)}`
}

export function loadAuthenticatedFile (baseUrl, path) {
  return api.get(authenticatedFileUrl(baseUrl, path), { responseType: 'blob' })
}

export async function downloadAuthenticatedFile (baseUrl, path, filename) {
  const response = await loadAuthenticatedFile(baseUrl, path)
  const objectUrl = window.URL.createObjectURL(response.data)
  const link = document.createElement('a')
  link.href = objectUrl
  link.download = filename || 'download'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000)
}



// WEBPACK FOOTER //
// ./src/utils/authenticatedFile.js